﻿import { createFileRoute } from "@tanstack/react-router";
import { MsgMensagensPage } from "@/paginas/pg_msg/msg-mensagens";

export const Route = createFileRoute("/_authenticated/msg-mensagens")({
  head: () => ({
    meta: [
      { title: "Mensagens da equipe — Milky Moo Palmares" },
      {
        name: "description",
        content: "Mural de conversa pública da equipe, com registro de quem enviou cada mensagem.",
      },
      { property: "og:title", content: "Mensagens da equipe — Milky Moo Palmares" },
      {
        property: "og:description",
        content: "Chat interno público e autenticado entre os usuários do sistema.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: MsgMensagensPage,
});
